import Breadcrumbs from "../components/Breadcrumbs";
import { EmailLink } from "../components/ContactInfo";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-8 py-14" data-testid="privacy-page">
      <Breadcrumbs items={[{ label: "Privacy" }]} />
      <h1 className="font-playfair text-4xl sm:text-5xl text-neutral-900 tracking-tight leading-[1.05] mb-6">
        Privacy Policy
      </h1>
      <div className="editorial-prose">
        <p>
          This Privacy Policy describes how SaaSRadarHub ("we," "us," or "our")
          collects, uses, and shares information when you use our website.
          This is a general placeholder that should be reviewed and
          customized before relying on it for production use.
        </p>
        <h2>Information we collect</h2>
        <p>
          We may collect information you provide directly (for example, when
          submitting the contact form), as well as basic analytics data such
          as page views and referral sources.
        </p>
        <h2>How we use information</h2>
        <p>
          We use information to respond to inquiries, improve our content,
          and understand how readers use the site.
        </p>
        <h2>Cookies and analytics</h2>
        <p>
          We use Google Analytics 4 to understand how readers use the site,
          such as which pages are visited and for how long. Google Analytics
          uses cookies and collects usage data such as pages viewed, approximate
          location and device type. You can control cookies through your browser
          settings or use Google's opt-out browser add-on.
        </p>
        <h2>Contact</h2>
        <p>
          Questions about this policy? Email us at <EmailLink testid="privacy-email" />.
        </p>
      </div>
    </div>
  );
}
